import { render, staticRenderFns } from "./SectionEditor.vue?vue&type=template&id=31a2225b&scoped=true&"
import script from "./SectionEditor.vue?vue&type=script&lang=js&"
export * from "./SectionEditor.vue?vue&type=script&lang=js&"
import style0 from "./SectionEditor.vue?vue&type=style&index=0&id=31a2225b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a2225b",
  null
  
)

export default component.exports